import { createSelector } from "reselect";
import _ from "underscore";

import getScanDatasetsForFloorByFirebaseId from "./get_scan_datasets_for_floor_by_firebase_id";
import ScanDataset from "../../../models/domain/scan_dataset";

// The "Most recent scan" option in the deviation export means the most recent scan
// uploaded for the floor (per product), which is not necessarily the scan the user
// currently has open. Deviations are computed from pointcloud data, so this resolves
// to the floor's latest-dated scan that actually captured a pointcloud and ignores any
// more recent photo-only reality capture — so the export flow's scan-scope card,
// filename preview, and the exported scan itself all name the right scan.
const getMostRecentScanDatasetForFloor = createSelector([
  getScanDatasetsForFloorByFirebaseId
], (scanDatasetsByFirebaseId): ScanDataset | null => {
  const scanned = _(scanDatasetsByFirebaseId).values().filter((scanDataset: ScanDataset) => ScanDataset.hasPointcloud(scanDataset) && scanDataset?.scanDate != null);
  if (!scanned.length) {
    return null;
  }
  return _.max(scanned, (scanDataset: ScanDataset) => new Date(scanDataset.scanDate).valueOf()) as ScanDataset;
});

export default getMostRecentScanDatasetForFloor;
